import React from 'react';
import { Link } from 'react-router-dom';

function TermAndConditions() {
  return (
    <>
      <section class="contact-info-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <h2>Terms & Conditions</h2>

              <div className="legalSection">
                <p>
                  The Platform is owned by <strong>Pargati Online Services</strong>, having its registered
                  office at SCO Number 832, Chandigarh, India (“Platform Owner”, “we”, “us”, “our”).
                </p>

                <p>
                  By accessing, browsing, or using the Platform, you agree to be bound by these Terms of Use.
                  If you do not agree, please do not use the Platform.
                </p>

                <ul>
                  <li><i class="flaticon-check"></i>You must provide accurate and complete information during registration.</li>
                  <li><i class="flaticon-check"></i>You are responsible for all activities conducted through your account.</li>
                  <li><i class="flaticon-check"></i>The Platform and Services are used at your own risk.</li>
                  <li><i class="flaticon-check"></i>All content is proprietary and protected by intellectual property laws.</li>
                  <li><i class="flaticon-check"></i>Unauthorized use may result in legal action.</li>
                  <li><i class="flaticon-check"></i>You agree not to use the Platform for unlawful purposes.</li>
                  <li><i class="flaticon-check"></i>Third-party links are governed by their own policies.</li>
                  <li><i class="flaticon-check"></i>You agree to pay applicable charges for availing services.</li>
                </ul>

                <p>
                  These Terms shall be governed by the laws of India. All disputes shall be subject
                  to the exclusive jurisdiction of courts in Chandigarh, India.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermAndConditions;
